import React from "react";
import { observer } from "mobx-react-lite";
import MonthPicker from "components/ui/form/month-picker";
import SelectX from "components/ui/form/select";
import { FilterProps, useHandleChange, getOptions } from "../shared";

const Filter = observer((props: FilterProps) => {
    const { state, users, handleChange, download, isLoading } = props;
    const { handleSelectChange, handleEventChange } = useHandleChange(handleChange, true);
    const minStartDate = new Date(1980, 1, 1);

    if (users == null) {
        return null;
    }

    const options = getOptions(users);

    return (
        <div className="row">
            <div className="col react-select">
                <SelectX
                    initialValue={state.ciamId}
                    options={options}
                    disabled={isLoading}
                    borderBottom="0"
                    name="ciamId"
                    label="User"
                    isClearable={false}
                    onHandleChange={handleSelectChange} />
            </div>

            <div className="col">
                <MonthPicker
                    id="startDate"
                    uniqueId="desktop-start-date"
                    disabled={isLoading}
                    initialValue={state.startDate}
                    minDate={minStartDate}
                    maxDate={state.endDate}
                    onChange={handleEventChange}
                    placeholder="From" />
            </div>

            <div className="col field-to">
                <MonthPicker
                    id="endDate"
                    uniqueId="desktop-end-date"
                    disabled={isLoading}
                    initialValue={state.endDate}
                    minDate={state.startDate}
                    maxDate={state.maxDate}
                    onChange={handleEventChange}
                    placeholder="To" />
            </div>

            <div className="col button">
                <button type="button" className="download" onClick={download} disabled={isLoading}>
                    <i></i>
                    <span>Export to Excel</span>
                </button>
            </div>
        </div>);
});

export default Filter;
